import * as React from "react";
import * as Scrivito from "scrivito";
import { MediaComponent } from "components";
import MoreTextLinkComponent from "./MoreTextLinkComponent";

const MediaRightComponent = Scrivito.connect(({ widget }) => {
  const cssForTextSize =
    widget.get("mediaSize") === "large" ? "col-md-5" : "col-md-7";
  const cssForMediaSize =
    widget.get("mediaSize") === "small" ? "col-md-5" : "col-md-7";

  return (
    <React.Fragment>
      <div className={cssForTextSize} data-testid="media-right">
        {(widget.get("subtitle") || Scrivito.isInPlaceEditingActive()) && (
          <Scrivito.ContentTag tag="h5" content={widget} attribute="subtitle" />
        )}
        <Scrivito.ContentTag tag="div" content={widget} attribute="body" />
        <MoreTextLinkComponent widget={widget} />
      </div>
      <div className={cssForMediaSize}>
        <MediaComponent widget={widget} />
      </div>
    </React.Fragment>
  );
});

export default MediaRightComponent;
